import { lazy } from 'react';
import { RouteConfig } from 'react-router-config';

/**
 * Schema Form Playground 路由配置
 */
export const schemaFormPlaygroundRoutes = (): RouteConfig[] => [
  {
    path: '/schema-playground',
    exact: true,
    name: 'Schema Form Playground',
    component: lazy(() => import('@/presentation/pages/schema-form-playground')),
    hideInMenu: true, // 隐藏菜单，作为开发测试页面
    requireSuperAdmin: true, // 仅超管可访问
  },
  {
    path: '/form-next-playground',
    exact: true,
    name: 'TdsFormNext Test',
    component: lazy(() => import('@/presentation/pages/tds-form-next-test')),
    hideInMenu: true, // 隐藏菜单，作为开发测试页面
    requireSuperAdmin: true, // 仅超管可访问
  },
];

